
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epoch/winners",
      function () {
        return require("private-next-pages/epoch/winners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epoch/winners"])
      });
    }
  